<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('scripting.generateReturnCode')"
    :visible.sync="addDialog"
    width="550px"
    @close="resetForm('ruleForm')"
  >
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      class="demo-ruleForm"
      label-position="top"
    >
      <el-form-item :label="$t('customerManagements.site')" prop="nextSiteId">
        <el-select
          v-model="ruleForm.nextSiteId"
          :placeholder="$t('GlobalSetObj.pleaseChoose')"
          clearable
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="item in nextSiteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!--  车牌号   -->
      <el-form-item :label="$t('GlobalSetObj.licensePlateNumber')" prop="vehicleNumber">
        <el-select
          v-model="ruleForm.vehicleNumber"
          :placeholder="$t('GlobalSetObj.pleaseChoose')"
          :remote-method="getVehicleNumber"
          clearable
          filterable
          remote
          reserve-keyword
          style="width: 100%"
          @focus="getVehicleNumber(ruleForm.vehicleNumber)"
        >
          <el-option
            v-for="(item, index) in vehicleNumberList"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <div style="text-align: right">
          <el-button @click="resetForm('ruleForm')">{{ $t('roleManage.cancel') }}</el-button>
          <el-button
            type="primary" @click="submitForm('ruleForm')"
          >{{ $t('roleManage.confirm') }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { generateReturnCode } from '@/api/storeAdmin';
import { vehicleTagNumber } from '@/api/orderApi';

export default {
  props: {
    nextSiteList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      addDialog: false,
      ruleForm: {
        nextSiteId: '',
        vehicleNumber: ''
      },
      rules: {
        vehicleNumber: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        nextSiteId: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ]
      },
      vehicleNumberList: []
    };
  },
  methods: {
    // 加载弹框
    showAddDialog() {
      this.addDialog = true;
      this.getVehicleNumber('');
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          generateReturnCode(this.ruleForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.$refs[formName].resetFields();
              this.addDialog = false;
              this.$emit('search');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addDialog = false;
    },
    // 车牌号
    getVehicleNumber(val) {
      const data = {
        number: val,
        queryType: 1
      };
      vehicleTagNumber(data).then((res) => {
        if (res.code === 200) {
          this.vehicleNumberList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped></style>
